// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentArea_GwbFz {
}

.messageContainer_y5XmW {
  background: var( --color-base025 );
  border: 1px solid var( --color-base300 );
  border-radius: 8px;
  padding: 11px;
}

.messageIcon_iVtQA {
  size : 24px;
  margin-right : 12px;
}

.messageText_OWfvT {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: var( --color-base700 );
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/locatorReconciliation/LocatorDialog.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":[".contentArea {\n}\n\n.messageContainer {\n  background: var( --color-base025 );\n  border: 1px solid var( --color-base300 );\n  border-radius: 8px;\n  padding: 11px;\n}\n\n.messageIcon {\n  size : 24px;\n  margin-right : 12px;\n}\n\n.messageText {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 24px;\n  color: var( --color-base700 );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentArea": `contentArea_GwbFz`,
	"messageContainer": `messageContainer_y5XmW`,
	"messageIcon": `messageIcon_iVtQA`,
	"messageText": `messageText_OWfvT`
};
export default ___CSS_LOADER_EXPORT___;
